import React from 'react';
import Masonry from 'react-masonry-component';
import { useInView } from 'react-intersection-observer';
import { addQueryString, qsToObject, masonryOptions, defaultMapState } from './utils'
import GoogleMap from './GoogleMap'




const CityIsAGym = () => {
  const [ref, inView] = useInView({ rootMargin: '0px 0px 0px 0px', triggerOnce: true });
  const [response, setresponse] = React.useState();
  const [hits, sethits] = React.useState();
  const [view, setview] = React.useState(localStorage.getItem("view") || 'list-view');


  const [showLoader, setshowLoader] = React.useState(false)
  const [updateFilters, setupdateFilters] = React.useState(false)

  const queriesObject = qsToObject(window.location.search);


  let config = window.ciagonConfig;






  React.useEffect(() => {
    //    if (inView) {


    console.log("use effect run")








    setshowLoader(true)
    //console.log(`${config.apiUrl}?parentPageId=2529&pageNumber=1&pagesize=100&eventTypeId=3529&filterDate=&searchTerm=&culture=en-US`)
    let apiUrl = `${config.apiUrl}?componentId=${config.componentId}&locationId=${queriesObject.locationId || config.locationId}&traineeId=${queriesObject.traineeId || config.traineeId}&culture=${config.culture}`


    fetch(apiUrl)
      .then(result => result.json())
      .then(
        (result) => {

           console.log(result)

          setresponse(result)

          //     console.log(result.ciag_items)
          sethits(result && result.ciag_items)


          // setupdateFilters(false)


          setshowLoader(false)

        },
        (error) => {
          setshowLoader(false)
          console.error(error)
        }
      )
    //   }
  }, [updateFilters])

  const setComponentView = (view) => {
    // console.log(view)
    localStorage.setItem("view", view);
    setview(view)
  }

  const setFilters = (value, filterName) => {

    addQueryString(filterName, value)
    setupdateFilters(!updateFilters)
  }

  return (
    <div ref={ref}>


      {showLoader && (
        <div className="ajax-loader">

        </div>
      )}

      <div className="explore-whats-on__search">
        <div className="explore-whats-on__col">
          <div className={`custom-link custom-link__date-filter ${view === 'map-view' ? 'active' : ''}`} onClick={() => { setComponentView('map-view') }}>
            <span className="icon icon-map custom-link__icon"></span>
            <div className="custom-link__label">
              <div className="custom-link__value">
                {response && response.dictionary_items && response.dictionary_items.MapView}
                {/* Map <br /> View */}
              </div>
            </div>
          </div>
          <div className={`custom-link custom-link__date-filter ${view === 'list-view' ? 'active' : ''}`} onClick={() => { setComponentView('list-view') }}>
            <span className="icon icon-list custom-link__icon"></span>
            <div className="custom-link__label">

              <div className="custom-link__value">
                {response && response.dictionary_items && response.dictionary_items.ListView}
                {/* List
                                        <br />
                                        View */}
              </div>

            </div>
          </div>

        </div>

      </div>
      <div className="explore-whats-on__filters">
        <ul className="explore-whats-on__items has-dropdown">
          <li className="explore-whats-on__item active">

            <span>{response && response.dictionary_items && response.dictionary_items.FilterLocation}</span>
            <div className="has-dropdown-inner">

              <ul>
                {response && response.locations && response.locations.map((item, index) => {
                  return <li key={index}><span
                    className={`${item && item.id == (queriesObject.locationId || config.locationId) ? 'active' : ''} `}
                    onClick={() => {
                      setFilters(item.id, 'locationId')
                    }} data-id={item.id}>{item.title}</span></li>
                })}
              </ul>
            </div>
          </li>
          <li className="explore-whats-on__item active">
            <span>{response && response.dictionary_items && response.dictionary_items.FilterTrainee}</span>
            <div className="has-dropdown-inner">

              <ul>
                {response && response.trainees && response.trainees.map((item, index) => {
                  return <li key={index}><span
                    className={`${item && item.id == (queriesObject.traineeId || config.traineeId) ? 'active' : ''} `}
                    onClick={() => {
                      setFilters(item.id, 'traineeId')
                    }} data-id={item.id}>{item.title}</span></li>
                })}

              </ul>
            </div>
          </li>
          {/* <li className="explore-whats-on__item active">
            <a href="#.">Trainer</a>
            <div className="has-dropdown-inner">

              <ul>
                <li><a href="#.">Location</a></li>
                <li><a href="#.">Location</a></li>
                <li><a href="#.">Location</a></li>
                <li><a href="#.">Location</a></li>
                <li><a href="#.">Location</a></li>
                <li><a href="#.">Location</a></li>
              </ul>
            </div>
          </li> */}
        </ul>
      </div>
      {view === 'list-view' ? (


        <div className="explore-whats-on__grid">
          <div className="masonry__grid">


            <Masonry
              className={' grid'} // default ''
              elementType={'div'} // default 'div'
              options={masonryOptions} // default {}
              disableImagesLoaded={false} // default false
              updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
            // imagesLoadedOptions={imagesLoadedOptions} // default {}
            >

              {hits && hits.map((item, index) => {

                return (



                  <div key={index} data-end-date={item && item.event_end_date} data-start-date={item && item.event_start_date} className={`grid-item  
                ${index === 0 ? 'grid-item--large' : ''}
                ${index === 2 ? 'grid-item--large' : ''}
                ${index === 3 ? 'grid-item--large' : ''}
                
                `}>


                    <div className="masonry__item">
                      {/* <div className="masonry__category">
                        {item && item.event_type_text || item.article_type_text}
                      </div> */}
                      <div className="masonry__image">
                        <img src={item && item.thumbnail || '/Common/images/placeholder.jpg'} alt="image" />
                      </div>
                      <div className="masonry__content">
                        <h6 className="masonry__sub-heading">{item && item.location && item.location.title}</h6>
                        <h4 className="masonry__heading">{item && item.title}</h4>
                        <div className="masonry__extras">
                          <p className="masonry__para">{item && item.summary} </p>
                          <div className="masonry__btns">
                            <a href={item && item.url} className="btn btn-rounded btn-rounded-white masonry__btn">
                              {response && response.dictionary_items && response.dictionary_items.SeeDetails}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                )
              })}

            </Masonry>


          </div>


        </div>
      ) : (
          <div className='map-view'>



            <GoogleMap mapState={hits} SeeDetails={response && response.dictionary_items && response.dictionary_items.SeeDetails}/>

          </div>
        )}

      {hits && hits.length === 0 && (

        <div className='no-results'>
          <div className="container">

            <div className="row">
              <div className="col-10 offset-md-1">
                <h2>


                  {response && response.dictionary_items && response.dictionary_items.EventResultNotFound || response.dictionary_items.NoArticleFound}
                </h2>
              </div>
            </div>

          </div>
        </div>
      )}


    </div>
  )
}


export default CityIsAGym;
